import * as React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  PageSection,
  Split,
  SplitItem,
} from '@patternfly/react-core';
import { CloseIcon } from '@patternfly/react-icons/dist/esm/icons/close-icon';
import classnames from 'classnames';
import { useLocalStorage } from '../../shared/hooks/useLocalStorage';
import './GettingStartedCard.scss';

type GettingStartedCardProps = {
  imgClassName?: string;
  localStorageKey: string;
  title: string;
  imgSrc?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  imgAlt?: string;
  hasHorizontalPadding?: boolean;
};

const LOCAL_STORAGE_KEY = 'getting-started-card';

export const GettingStartedCard: React.FC<React.PropsWithChildren<GettingStartedCardProps>> = ({
  imgClassName,
  localStorageKey,
  title,
  imgSrc,
  imgAlt,
  children,
  hasHorizontalPadding = true,
}) => {
  const [storageKeys, setStorageKeys] = useLocalStorage<{ [key: string]: boolean }>(
    LOCAL_STORAGE_KEY,
  );

  const keys = storageKeys && typeof storageKeys === 'object' ? storageKeys : {};
  const isDismissed = keys[localStorageKey];
  const SvgIcon = imgSrc;

  return (
    !isDismissed && (
      <PageSection
        hasBodyWrapper={false}
        className={`pf-v6-u-py-xl ${hasHorizontalPadding ? '' : 'pf-v6-u-px-0'}`}
      >
        <Card>
          <Split>
            {imgSrc && (
              <SplitItem
                className={classnames('pf-v6-u-min-width getting-started-card__img', imgClassName)}
              >
                <SvgIcon aria-label={imgAlt} role="img" />
              </SplitItem>
            )}
            <SplitItem isFilled>
              <CardHeader
                actions={{
                  actions: (
                    <>
                      <Button
                        icon={<CloseIcon />}
                        variant="plain"
                        aria-label="Hide card"
                        onClick={() => setStorageKeys({ ...keys, [localStorageKey]: true })}
                      />
                    </>
                  ),
                  hasNoOffset: false,
                  className: undefined,
                }}
              >
                <CardTitle>{title}</CardTitle>
              </CardHeader>
              <CardBody>{children}</CardBody>
            </SplitItem>
          </Split>
        </Card>
      </PageSection>
    )
  );
};
